export default "__VITE_ASSET__62b51661__"